// src/api/aiMessagingApi.ts
// RTK Query API for AI-powered messaging assistance

import { baseApi } from './baseApi';
import type {
  ThreadSummary,
  ReplySuggestion,
  SuggestedAction,
  ThreadAssistantResponse,
  ContactCommunicationSummary,
  AIMessagingStatusResponse,
} from '../types/api';

export const aiMessagingApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // =============================================
    // Status
    // =============================================
    getAIMessagingStatus: builder.query<AIMessagingStatusResponse, void>({
      query: () => '/ai/messaging/status',
    }),

    // =============================================
    // Thread Summary
    // =============================================
    getThreadSummary: builder.query<ThreadSummary, string>({
      query: (threadId) => `/ai/messaging/threads/${threadId}/summary`,
    }),

    // =============================================
    // Reply Suggestions
    // =============================================
    getThreadSuggestions: builder.query<{ suggestions: ReplySuggestion[] }, string>({
      query: (threadId) => `/ai/messaging/threads/${threadId}/suggestions`,
    }),

    // =============================================
    // Detected Actions
    // =============================================
    getThreadActions: builder.query<{ actions: SuggestedAction[] }, string>({
      query: (threadId) => `/ai/messaging/threads/${threadId}/actions`,
    }),

    // =============================================
    // Combined Thread Assistant Data
    // =============================================
    getThreadAssistant: builder.query<ThreadAssistantResponse, string>({
      query: (threadId) => `/ai/messaging/threads/${threadId}/assistant`,
    }),

    // =============================================
    // Contact Communication Summary
    // =============================================
    getContactCommunicationSummary: builder.query<ContactCommunicationSummary, string>({
      query: (contactId) => `/ai/messaging/contacts/${contactId}/summary`,
    }),
  }),
});

export const {
  useGetAIMessagingStatusQuery,
  useGetThreadSummaryQuery,
  useGetThreadSuggestionsQuery,
  useGetThreadActionsQuery,
  useGetThreadAssistantQuery,
  useGetContactCommunicationSummaryQuery,
} = aiMessagingApi;
